import { createRouter, createWebHistory } from 'vue-router'
import Landing from '../views/Landing.vue'
import Home from '../views/Home.vue'
import CrmPage from '../views/CrmPage.vue';
import Booking from  '../views/Booking.vue'
import BookingClient from  '../views/BookingClient.vue'
import Inventory from "../views/Inventory.vue"
import JobManagement from  '../views/JobManagement.vue'
import AdminNewVoucher from "../views/AdminNewVoucher.vue"
import Invoice from "../views/Invoice.vue"
import InvoiceList from "../views/InvoiceList.vue"
import InvoiceEdit from "../views/InvoiceEdit.vue"
import JobStartEnd from  '../views/JobStartEnd.vue'
import AdminVoucher from "../views/AdminVoucher.vue"
import SignDoc from "../views/SignDoc.vue"
import Success from "../views/Success.vue"
import JobManagementClient from  '../views/JobManagementClient.vue'
import JobManagementDriver from  '../views/JobManagementDriver.vue'
import ForgetPassword from '../views/ForgetPassword.vue'


import NotFound from '../views/404.vue';

// import ClientDashboard from '../views/ClientDashboard.vue'
// import HumanResource from  '../views/HumanResource.vue'
// import SignUp from "../views/SignUp.vue"
// import Tutorial from "../views/Tutorial.vue"
// import DriverJob from "../views/DriverJob.vue"
// import EditSignDoc from "../views/EditSignDoc.vue"
// import JobList from "../views/JobList.vue"
// import JobFullList from "../views/JobFullList.vue"
// import DriverVoucher from "../views/DriverVoucher.vue"
// import DriverNewVoucher from "../views/DriverNewVoucher.vue"
// import DriverVoucherList from "../views/DriverVoucherList.vue"
// import JobManagementAdmin from "../views/JobManagementAdmin.vue"


const routes = [
  { path: '/',component: Landing },
  { path: '/login',component: Home },
  { path: '/crm', component: CrmPage },
  { path: '/Booking', component: Booking },
  { path: '/BookingClient', component: BookingClient },
  { path: '/Inventory', component: Inventory },
  { path: '/JobManagement', component: JobManagement },
  { path: '/JobManagementClient', component: JobManagementClient },
  { path: '/JobManagementDriver', component: JobManagementDriver },
  { path: '/AdminNewVoucher/:id', component: AdminNewVoucher },
  { path: '/JobStartEnd/:token', component: JobStartEnd },
  { path: '/AdminVoucher/:voucherId', component: AdminVoucher },
  { path: '/SignDoc/:jobId/:token', component: SignDoc },
  { path: '/Success/:jobId/:token', component: Success },
  { path: '/AdminVoucher/:voucherId', component: AdminVoucher },
  { path: '/Invoice', component: Invoice },
  { path: '/InvoiceList', component: InvoiceList },
  // :invoiceId is the Firestore document id. Older links carrying an invoice
  // number still resolve — the API falls back to a lookup by number.
  { path: '/Invoice/edit/:invoiceId', component: InvoiceEdit },
  { path: '/ForgetPassword', component: ForgetPassword },


  // // { path: '/SignUp', component: SignUp, name: 'SignUp' },
  // // { path: '/clientDashBoard/:id', component: ClientDashboard, name: 'ClientDashboard' },
  // // { path: '/HumanResource', component: HumanResource },
  // { path: '/JobManagementAdmin/:token', component: JobManagementAdmin },
  // { path: '/DriverJob', component: DriverJob },
  // { path: '/EditSignDoc/:id/:token', component: EditSignDoc },
  // { path: '/JobList/:token', component: JobList },
  // { path: '/JobFullList/:token', component: JobFullList },

  // { path: '/DriverVoucher/:voucherId', component: DriverVoucher },
  // { path: '/DriverNewVoucher/:id', component: DriverNewVoucher },
  // { path: '/DriverVoucherList', component: DriverVoucherList },


  // { path: '/Tutorial', component: Tutorial },
  
  { path: '/:pathMatch(.*)*', component: NotFound },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
